import { t } from 'i18next';
import { TFunction } from 'react-i18next';
import { GoalFields, Goal, GoalAction, GoalStep } from 'types/Goal';

interface GetGoalRowsType {
	label: string;
	type: GoalFields;
	arr?: GoalAction[] | GoalStep[];
	text?: string;
	required?: boolean;
	isExtended?: boolean;
}

const getGoalRows: (goalData: Goal, t: TFunction<'translation', undefined>) => GetGoalRowsType[] = ({
	goal,
	change,
	priorities,
	notes,
	deadlineAndReview,
	areaOfInfluence,
	steps,
	actions,
}) => [
	{
		label: t('userPanel.goal.agreedGoal'),
		type: 'goal',
		text: goal,
		required: true,
	},
	{
		label: t('userPanel.goal.expectedChange'),
		type: 'change',
		text: change,
	},
	{
		label: t('userPanel.goal.deadlineAndReview'),
		type: 'deadlineAndReview',
		text: deadlineAndReview,
	},
	{
		label: t('userPanel.goal.steps'),
		type: 'steps',
		arr: steps,
	},
	{
		label: t('userPanel.goal.areaOfInfluence'),
		type: 'areaOfInfluence',
		text: areaOfInfluence,
		isExtended: true,
	},
	{
		label: t('userPanel.goal.actions'),
		type: 'actions',
		arr: actions,
		isExtended: true,
	},
	{
		label: t('userPanel.goal.priorities'),
		type: 'priorities',
		text: priorities,
		isExtended: true,
	},
	{
		label: t('userPanel.goal.notes'),
		type: 'notes',
		text: notes,
		isExtended: true,
	},
];

export default getGoalRows;
